import React from "react";
import { __ } from "@wordpress/i18n";
import { Section } from "../section";
import { PluginCard } from "./plugin-card";

// Access the localized free plugins data
const FREE_PLUGINS_OBJ = window.wpmudev_cross_sell_data.free_plugins || [];
const FREE_PLUGINS = Object.values(FREE_PLUGINS_OBJ);

const PluginsFree = () => {
  return (
    <Section
      title={__(
        "Try our other highly-rated free WordPress plugins",
        "plugin-cross-sell-textdomain"
      )}
      description={__(
                "From security to SEO to marketing, we’ve got you covered.",
                "plugin-cross-sell-textdomain"
              )}
      className="cross-sell-plugins--free"
    >
      {FREE_PLUGINS.length > 0 && (
        <div className="cross-sell-grid">
          {FREE_PLUGINS.map((plugin) => (
            <PluginCard key={plugin.slug} cta={true} {...plugin} />
          ))}
        </div>
      )}
    </Section>
  );
};

export { PluginsFree };
